module.exports = __webpack_public_path__ + "static/img/cg.4396b867.svg";